export const verticalSpacing = (space) => {
    switch (space) {
    case "small":
        return "my-4 md:my-8";

    case "medium":
        return "my-8 md:my-16";

    case "large":
        return "my-16 md:my-32";
  
    default:
        return null;
    }
};

export const customBgColor = (bgColor) => bgColor?.hex ?? "#fff";
